// removed by extract-text-webpack-plugin
module.exports = {"portal-notifications-wrapper":"portal-notifications-wrapper___ZvZy1","portal-notifications-card":"portal-notifications-card___3Z-rz"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/components/notification-sidenav/notifications-tab.module.scss
// module id = 423
// module chunks = 8